if (!customElements.get('gift-card-media')) {
  customElements.define(
    'gift-card-media',
    class GiftCardMedia extends HTMLElement {
      connectedCallback() {
        this.product = this.closest('product-info');
        this.changeHandler = (event) => {
          if (!event.target.matches('input[type="radio"]')) return;
          const amount = event.target.value.replace(/[^0-9]/g, '').replace(/00$/, '');
          this.show(amount);
        };
        this.product?.addEventListener('change', this.changeHandler);
        this.show(this.dataset.selectedAmount);
      }

      disconnectedCallback() {
        this.product?.removeEventListener('change', this.changeHandler);
      }

      show(amount) {
        this.querySelectorAll('[data-gift-card-amount]').forEach((image) => {
          const selected = image.dataset.giftCardAmount === amount;
          image.classList.toggle('gift-card-media__image--hidden', !selected);
          image.toggleAttribute('aria-hidden', !selected);
        });
      }
    }
  );
}
